import Dropzone from 'react-dropzone'

import { Box, Button, theme } from '@factorialco/deprecated-design-system'
import { F0Icon, F0Text } from '@factorialco/f0-react'
import { Upload } from '@factorialco/f0-react/icons/app'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import 'modules/posts/components/ManagePost/ImageUploader/index.styles.css'
import { PostFormValues } from 'modules/posts/components/ManagePost/types'
import { coverImageAccept } from 'modules/posts/lib/coverImageMimeTypes'
import { isVideo } from 'modules/posts/lib/isVideo'

const ImageUploader = () => {
  const form = useFormContext<PostFormValues>()

  const onDrop = (files: File[]) => {
    const image = files[0]
    form.setFieldValue('coverImageUrl', image)
  }

  const deleteImage = () => form.setValues({ ...form.values, coverImageUrl: null })
  const hasVideo =
    form.values.coverImageUrl instanceof File
      ? form.values.coverImageUrl.type.includes('video')
      : isVideo(form.values.coverImageUrl)

  return (
    <Box
      className={'ImageUploader_dropzone'}
      aria-label={i18n.t('posts.communities.aria_label_image_uploader')}
      style={{
        border: form.values.coverImageUrl
          ? 'none'
          : `${theme.dimensions.s2} dashed ${theme.colors.grey400}`,
        backgroundImage:
          !hasVideo && form.values.coverImageUrl
            ? `url(${
                form.values.coverImageUrl instanceof File
                  ? URL.createObjectURL(form.values.coverImageUrl)
                  : form.values.coverImageUrl
              })`
            : ``,
      }}
    >
      {form.values.coverImageUrl && (
        <Box className={'ImageUploader_dropzoneActions'}>
          <PopoverMenu type="list">
            <PopoverMenu.Trigger>
              <Button.Decorative type="primary" iconName="ellipsis" />
            </PopoverMenu.Trigger>
            <PopoverMenu.Content side="bottom" align="center">
              <PopoverMenu.TouchableOption
                title={
                  hasVideo
                    ? i18n.t('posts.communities.delete_video')
                    : i18n.t('posts.event.delete_photo')
                }
                onClick={deleteImage}
                danger
              />
            </PopoverMenu.Content>
          </PopoverMenu>
        </Box>
      )}
      <Dropzone onDrop={onDrop} accept={coverImageAccept} multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <>
            <div
              className={'ImageUploader_dropzoneDimensions'}
              {...getRootProps()}
              style={{ display: hasVideo ? 'none' : 'block' }}
            >
              <input {...getInputProps()} />
              {!form.values.coverImageUrl && (
                <Box
                  alignItems="center"
                  justifyContent="center"
                  height="full"
                  width="full"
                  gap="s8"
                >
                  <F0Icon icon={Upload} size="md" color="secondary" />
                  <F0Text
                    variant="body"
                    style={{ fontWeight: 500 }}
                    content={i18n.t('posts.communities.add_media')}
                  />
                  <F0Text
                    variant="description"
                    style={{ fontWeight: 400 }}
                    content={i18n.t('posts.communities.add_media_subtitle')}
                  />
                  <F0Text
                    variant="description"
                    style={{ fontWeight: 400 }}
                    content={i18n.t('posts.communities.add_media_subtitle_size')}
                  />
                </Box>
              )}
            </div>
            {hasVideo && form.values.coverImageUrl && (
              <video controls className={'ImageUploader_dropzoneVideo'}>
                <source
                  src={
                    form.values.coverImageUrl instanceof File
                      ? URL.createObjectURL(form.values.coverImageUrl)
                      : form.values.coverImageUrl
                  }
                />
              </video>
            )}
          </>
        )}
      </Dropzone>
    </Box>
  )
}

export default observer(ImageUploader)
